module.exports = __webpack_public_path__ + "static/img/russianroulette_esp.780fb02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/russianroulette_esp.png
// module id = dZpR
// module chunks = 1